export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/mobile_apps.7a0b44e.svg";